<template>
  <div
    id="root"
    :class="{[theme]: theme, 'focus-visible': showFocus}"
  >
    <component
      :is="appComponent"
      v-if="ready"
    />
    <connection-error :show="connectionError" />
  </div>
</template>

<script>
import MasteryApp from '@/components/mastery-app';
import WuxApp from '@/components/wux-app';
import ConnectionError from '@components/singletons/connection-error';

export default {
  components: { MasteryApp, WuxApp, ConnectionError },
  computed: {
    appComponent() {
      if (this.masteryApp) {
        return 'MasteryApp';
      }
      return 'WuxApp';
    },
    showFocus() {
      return this.$store.getters['appState/showFocus'];
    },
    masteryApp() {
      return this.$store.getters['app/isMasteryApp'];
    },
    ready() {
      return this.$store.getters['app/appLoaded'] && (this.user || (this.$route.meta.public));
    },
    theme() {
      if (this.masteryApp) {
        return 'mastery';
      } else {
        return 'standard';
      }
    },
    user() {
      return this.$store.getters['session/currentUser'];
    },
    connectionError() {
      const connectionError = this.$store.getters['ui/connectionError'];
      return connectionError;
    },
    appLogo() {
      return this.$store.getters['app/appLogo'];
    },
  },
  watch: {
    appLogo: {
      immediate: true,
      handler(logo) {
        document.head.querySelectorAll('link[rel="icon"]').forEach(el => el.remove());
        if (!logo) return;
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = logo;
        document.head.appendChild(link);
      },
    },
  },
  mounted() {
    this.addTabListener();
    this.addMouseListener();
  },
  beforeUnmount() {
    this.removeMouseListener();
    this.removeTabListener();
  },
  methods: {
    addTabListener() {
      window.addEventListener('keydown', this.addFocusVisibility);
    },
    addMouseListener() {
      window.addEventListener('mousedown', this.removeFocusVisibility);
    },
    removeTabListener() {
      window.removeEventListener('keydown', this.addFocusVisibility);
    },
    removeMouseListener() {
      window.removeEventListener('mousedown', this.removeFocusVisibility);
    },
    addFocusVisibility(event) {
      if (event.key === 'Tab') {
        this.$store.dispatch('appState/setShowFocus', true);
        this.addMouseListener();
        this.removeTabListener();
      }
    },
    removeFocusVisibility(event) {
      this.$store.dispatch('appState/setShowFocus', false);
      this.addTabListener();
      this.removeMouseListener();
    },
  },
};
</script>

<style lang='scss'>
  @use '../style/base.scss' as *;

  #root:not(.focus-visible) {
    a,
    button,
    input,
    textarea {
      outline: none;
    }
  }
</style>
